import { Component, HostListener, Inject, Input, OnInit, Optional, ViewChild, ChangeDetectionStrategy } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { ActivatedRoute } from '@angular/router';

import { SearchSettingsModel, GridComponent, ExcelExportProperties, GridColumnModel, FilterService } from '@syncfusion/ej2-angular-grids';
import { DataManager, ODataV4Adaptor, Query } from '@syncfusion/ej2-data';
import { vrStatuses } from '../model/vacation-request.model';
import { VacationRequestService } from '../vacation-request.service';
import { SharedService } from 'projects/shared/src/lib/shared.service';
import { VacationRequestsPopupComponent } from './vacation-requests-popup/vacation-requests-popup.component';
import { Applications, ModuleNames, RolePermissionsModel, tabsModel } from '../../../models/lib.model';
import { GridPersistRequests, UserRoles } from '../../../lib.constants';
import { convertDateFormat, getCurrentDate } from '../../../utils/date-functions';
import { excelQueryCellInfo, getExcelDataSource, gridActionBeginForFilteringOdataV4, updateFilterIcon } from '../../../utils/grid-functions';
import { APP_CONFIG, AppConfig } from '../../../app-config.token';


let MASTER_API_URL = '';

@Component({
    selector: 'app-vacation-requests-grid',
    templateUrl: './vacation-requests-grid.component.html',
    styleUrls: ['./vacation-requests-grid.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class VacationRequestsGridComponent implements OnInit {

  // @Input('source') source: 'dashboard' | 'mainGrid' = 'mainGrid';
  showGrid: boolean = false;
  gridName = 'out-of-office-request-grid';
  ooData: any = [];
  gridHeight: number = window.innerHeight - 220;
  columns: any;
  vrStatuses: typeof vrStatuses = vrStatuses;
  deleteQuery = new Query().where('isDeleted', 'notequal', true);
  public pageSettings: any = { pageSizes: [20, 50, 100, 500], pageSize: 20 };
  @ViewChild('columnChooser') columnChooser: any;
  searchSettings!: SearchSettingsModel;
  ooGrid!: GridComponent;
  PERMISSIONS: RolePermissionsModel[] = [];
  tabsModel: typeof tabsModel = tabsModel;

  @ViewChild('ooGrid') set gridComponent(gridComponent: GridComponent) {
    if (gridComponent) {
      this.ooGrid = gridComponent;
      this.setGridToolbar();
    }
  }
  @HostListener('window:resize', ['$event'])
  onResize(event: Event) {
    this.gridHeight = window.innerHeight - 240;
  }
  constructor(
    public dialog: MatDialog,
    private readonly vrService: VacationRequestService,
    private readonly route: ActivatedRoute,
    @Optional() @Inject(MAT_DIALOG_DATA) public dialogData: any,
    @Optional() public dialogRef: MatDialogRef<VacationRequestsGridComponent>,
    @Inject(APP_CONFIG) private config: AppConfig,
    private readonly sharedService: SharedService
  ) {
    MASTER_API_URL = config.masterApiURL || '';
   }

  ngOnInit() {
    this.loadPermissions(true);
    this.getSetModuleStatuses();
    this.searchSettings = {
      fields: [
        'vrfId',
        'vacation',
        'floating',
        'sick',
        'other',
        'totalDays',
        'reporter',
        'status',
        'approvedBy'
      ]
    };
  }

  onRowDataBound(args: any) {
    const data = args.data;
    const $row = args.row;

    args.data.attColorCode && (args.row.getElementsByClassName('attachments-items')[0].style.color = args.data.attColorCode);    
    // args.data.linkColorCode && (args.row.getElementsByClassName('linked-items')[0].style.color = args.data.linkColorCode);
    args.data.commentColor && (args.row.getElementsByClassName('comments-items')[0].style.color = args.data.commentColor);
      
    if (data['canDelete']) {
      $row.getElementsByClassName('delete-item')[0]?.classList.remove('disabled-grid-button');
    } else {
      $row.getElementsByClassName('delete-item')[0]?.classList.add('disabled-grid-button');
    }
    if (data['canApprove']) {
      $row.getElementsByClassName('approve-request')[0]?.classList.remove('disabled-grid-button');
    } else {
      $row.getElementsByClassName('approve-request')[0]?.classList.add('disabled-grid-button');
    }
    if (data['canReject']) {
      $row.getElementsByClassName('reject-request')[0]?.classList.remove('disabled-grid-button');
    } else {
      $row.getElementsByClassName('reject-request')[0]?.classList.add('disabled-grid-button');
    }
  }


  onGridActionComplete(args: any, grid: any) {
    // gridActionsForFiltering(args, this.ooGrid);
    updateFilterIcon(args, this.ooGrid);
    if (GridPersistRequests.includes(args.requestType)) {
      this.updatePersistence(this.sharedService.getUserId(), this.ooGrid?.getPersistData());
    }
  }

  onCommandClick(args: any, grid) {
    // show Loader
    const data = args.rowData;
    switch (args.commandColumn.title) {
      case 'Details':
        this.openVRPopup(data);
        break;
      case 'Links':
        this.openVRPopup(data, tabsModel.links);
        break;
        case 'Comments':
          this.sharedService.globalComments = {
            grid, module: ModuleNames.VacationRequest, moduleId: args.rowData.vrfId, showComments: true
          }
          break;
          case 'Attachments':
            this.openVRPopup(data, tabsModel.attachments);
            break;
            case 'History':
              this.openVRPopup(data, tabsModel.history);
        break;
      case 'Reject Request':
        this.vrService.showCommentOnRejectionModal(args.rowData)
          .then((resp: any) => {
            this.ooGrid.refresh();
          });
        break;
      case 'Delete Request':
        const vrfId = args.rowData['vrfId'];
        this.sharedService.showConfirmation(`Are you sure to delete the request: ${vrfId}?`).then((res => {
          if (res.isConfirmed) {
            this.vrService.deleteRequest(vrfId).subscribe({
              next: (res: any) => {
                this.sharedService.showNotification("success", res);
                this.ooGrid.refresh();
              },
              error: (err: any) => {
                this.sharedService.showNotification("error", err?.message);
              }
            });;
          }
        }));
        break;

      case 'Approve Request':
        this.sharedService.showConfirmation(`Are you sure to approve the request: ${args.rowData['vrfId']}?`).then((res => {
          if(res.isConfirmed) {
              args.rowData['status'] = vrStatuses.approved;
              this.vrService.updateStatusTo(args.rowData).subscribe({
                next: (res: any) => {
                  this.sharedService.showNotification("success", res);
                  this.ooGrid.refresh();
                }
              });
            }
        }));
        break;
      default:
        console.warn('Unknown command column title:', args.commandColumn.title);
        break;
    }
  }
  updateVacationRequest(data) {
    this.vrService.saveVacationRequest(data).subscribe({
      next: (res: any) => {
        this.sharedService.showNotification("success", res?.message);
        this.ooGrid.refresh();
      },
      error: (err: any) => {
        this.sharedService.showNotification("error", err?.message)
      }
    });
  }
  onItemClick(event: any) {
    const data = {...event, statusCode: this.vrService.getVRStatus(event?.status)};
    this.openVRPopup(data);
  }
  openVRPopup(data: any, tab: tabsModel = tabsModel.details) {
    const dialogRef = this.dialog.open(VacationRequestsPopupComponent, {
      disableClose: true,
      maxWidth: '100vw',
      maxHeight: '100vh',
      width: '100%',
      height: '100%',
      enterAnimationDuration: '0',
      exitAnimationDuration: '0',
      data: {
        ...data,
        tab
      }
    });
    dialogRef.afterClosed().subscribe((d: any) => {
      this.onClose(d);
    });
  }
  onToolbarClick(args: any) {
    if (args.item.properties.id === 'add-new-record') {
      const data = {
        status: 'Open',
        statusCode: this.vrService.getVRStatus('Open'),
        canEdit: true,
        userId: this.sharedService.getUSER()?.userId,
        vrfId: null,
        other: [],
        reporter: this.sharedService.getUSER()?.firstName + " " + this.sharedService.getUSER()?.lastName
      }
      this.openVRPopup(data);
    } else if (args.item.id === 'excel-export') {
      const dataSource = getExcelDataSource(this.ooGrid);
      let excelExportProperties: ExcelExportProperties = {
        dataSource,
        hierarchyExportMode: 'Expanded',
        theme: {
          header: { bold: true, backColor: '#eeeeee', fontSize: 15 }
        },
        fileName: `Vacation Requests (${getCurrentDate()}).xlsx`
      };
      this.ooGrid?.excelExport(excelExportProperties);
    } else if (args.item.id === 'refresh') {
      this.loadPermissions();
    } else if (args.item.id === 'clear-filter') {
      this.ooGrid?.clearFiltering();
      this.ooGrid?.clearSorting();
      this.ooGrid?.search('');
      this.updatePersistence(); // clears persistence
      this.ooGrid?.refresh();
    }
  }
  updatePersistence(userId: string = this.sharedService.getUserId(), value: any = '', appName: Applications.RimsSales | Applications.RimsService | '' = Applications.RimsSales) {
    this.sharedService.savePersistence({ userId, name: this.gridName, value, appId: appName })
      .subscribe((res: any) => {
        localStorage.setItem(`grid${this.gridName}`, value ?? this.ooGrid?.getPersistData());
      });
  }
  loadPermissions(
    initData: boolean = false,
    category: string = 'outOfOfficeRequest',
    subCategory: string = 'outOfOfficeRequest_MainGrid',
    id: string = '',
    module: string = ''
  ) {
    this.sharedService.getRolePermission(category, subCategory, module, id).subscribe({
      next: (res: any) => {
        this.PERMISSIONS = res?.result ?? [];
        initData ? this.columns = this.getColumns() : null;
        this.initData();
      },
      error: (err: any) => {
        this.PERMISSIONS = [];
      }
    });
  }

  loadPage() {
    this.sharedService.getPersistence(this.gridName, this.sharedService.getUserId(), Applications.RimsSales)
      .subscribe({
        next: (res: any) => {
          if (res && res.result && res.result.length && res.result[0].value) {
            localStorage.setItem(`grid${this.gridName}`, res.result[0].value);
          } else {
            localStorage.removeItem(`grid${this.gridName}`);
          }
          setTimeout(() => {
            this.showGrid = true;
          }, 50);
        },
        error: (err) => {
          this.showGrid = true;
          this.sharedService.showNotification("error", err?.error?.message);
        }
      });
  }

    initData() {
    // if(this.dialogData?.filteredStatus || this.source == 'dashboard') {
      // this.deleteQuery = this.deleteQuery.where('status', 'equal',  vrStatuses.submitted);
    // }
      this.ooData = new DataManager({
        url: `${MASTER_API_URL}odata/vacationReq`,
        adaptor: new ODataV4Adaptor(),
        headers: [{ "Authorization": `Bearer ${localStorage.getItem('access_token')}` }],
      });
      setTimeout(() => {
        this.loadPage();
      }, 250);
    }
convertDateFormat(date: any): any {
  return convertDateFormat(date);
}
  setActionsColumn() {
    let approveIconPermissions = this.getPermission('mainGrid_approveRequest');
    let rejectIconPermissions = this.getPermission('mainGrid_rejectRequest');
    let deleteIconPermissions = this.getPermission('mainGrid_deleteRequest');

    const commands = [];

    if (approveIconPermissions?.visible) {
      const disableApproveClass = approveIconPermissions?.enable ? 'e-flat approve-request' : 'e-flat approve-request disabled-grid-button';
      commands.push({ title: 'Approve Request', buttonOption: { iconCss: `fas fa-check text-success`, cssClass: disableApproveClass } });
    }
    if (rejectIconPermissions?.visible) {
      const disableRejectClass = rejectIconPermissions?.enable ? 'e-flat reject-request' : 'e-flat reject-request disabled-grid-button';
      commands.push({ title: 'Reject Request', buttonOption: { iconCss: `fas fa-times text-danger`, cssClass: disableRejectClass } });
    }

    commands.push(
      { title: 'Details', buttonOption: { iconCss: `fas fa-tasks`, cssClass: 'e-flat details' } },
      { title: 'Comments', buttonOption: { iconCss: `fas fa-comment comments`, cssClass: 'e-flat comments-items' } },
      { title: 'Attachments', buttonOption: { iconCss: 'fas fa-file-upload', cssClass: 'e-flat attachments-items' } },
      { title: 'History', buttonOption: { iconCss: 'fas fa-history', cssClass: 'e-flat history-disable' } }
    );

    if (deleteIconPermissions?.visible) {
      commands.push({ title: 'Delete Request', buttonOption: { iconCss: `fas fa-trash`, cssClass: `e-flat delete-item` } });
    }

    return {
      field: 'Actions', headerText: 'Actions', width: 240, showInColumnChooser: false, allowEditing: false, textAlign: 'Center', allowFiltering: false, allowSorting: false, freeze: 'Right', allowReordering: false, commands
    }
  }

  getColumns() {
    return [
      { field: 'vrfId', headerText: 'ID', isPrimaryKey: true, allowEditing: false, textAlign: 'Left', allowFiltering: true, allowSorting: true, width: 120, showInColumnChooser: false, visible: true },
      { field: 'reporter', headerText: 'Reporter', type: 'string', allowEditing: false, textAlign: 'Left', width: 150, filter: { type: 'Excel' }, visible: true, showInColumnChooser: false},
      { field: 'startDate', headerText: 'Start Date', type: 'date', format: { type: 'date', format: 'd MMM, yyyy', isServerRendered: true }, allowEditing: false, textAlign: 'Left', width: 140, visible: true, showInColumnChooser: true, },
      { field: 'endDate', headerText: 'End Date', type: 'date', format: { type: 'date', format: 'd MMM, yyyy', isServerRendered: true }, allowEditing: false, textAlign: 'Left', width: 140, visible: true, showInColumnChooser: true, },
      { field: 'status', headerText: 'Status', type: 'string', filter: { type: 'Excel' }, allowEditing: false, textAlign: 'Left', width: 130, visible: true, showInColumnChooser: true },
      { field: 'totalDays', headerText: 'Total Days', type: 'number', format: "n", allowEditing: false, textAlign: 'Left', width: 145, visible: true, showInColumnChooser: true },
      { field: 'vacation', headerText: 'Vacation', type: 'number', format: "n", allowEditing: false, textAlign: 'Left', width: 135, visible: true, showInColumnChooser: true },
      { field: 'floating', headerText: 'Floating', type: 'number', format: "n", allowEditing: false, textAlign: 'Left', width: 130, visible: true, showInColumnChooser: true },
      { field: 'sick', headerText: 'Sick', type: 'number', format: "n", allowEditing: false, textAlign: 'Left', width: 110, visible: true, showInColumnChooser: true },
      { field: 'other', headerText: 'Others', type: 'number', format: "n", allowEditing: false, textAlign: 'Left', width: 125, visible: true, showInColumnChooser: true },
      { field: 'createdDate', headerText: 'Submission Date', type: 'date', format: { type: 'date', format: 'd MMM, yyyy' }, allowEditing: false, textAlign: 'Left', width: 185, visible: true, showInColumnChooser: true, },
      { field: 'approvedDate', headerText: 'Approved Date', type: 'date', format: { type: 'date', format: 'd MMM, yyyy' }, allowEditing: false, textAlign: 'Left', width: 170, visible: true, showInColumnChooser: true, },
      { field: 'approvedBy', headerText: 'Approved By', type: 'string', allowEditing: false, textAlign: 'Left', width: 160, visible: true, showInColumnChooser: false },
      this.setActionsColumn()
    ];
  }

  onGridCreated(event: any) {
    updateFilterIcon({ requestType: 'filtering' }, this.ooGrid);
    this.route.queryParamMap.subscribe(params => {
      const primaryId = params.get('primaryId');
      const showComments = params.get('showComments') === 'true';
      
      if (primaryId && showComments) {
        this.openVRPopup({ vrfId: primaryId }, tabsModel.details);
        setTimeout(() => {
          this.sharedService.globalComments = {
            grid: this.ooGrid,
            module: ModuleNames.VacationRequest,
            moduleId: primaryId,
            showComments: true
          };
        }, 500);
        return;
      }
    });
  }
  onExcelQueryCellInfo(args: any) {
    excelQueryCellInfo(args);
  }


  setGridToolbar() {
    let excelIconPermissions = this.getPermission('mainGrid_excelExport');
    let addIconPermissions = this.getPermission('mainGrid_createRequest');
    this.ooGrid.toolbar = [
      { id: 'column-chooser', template: this.columnChooser, tooltipText: 'Show/Hide Columns' },
      { id: 'refresh', align: 'Right', prefixIcon: 'fas fa-redo-alt', cssClass: 'mb-1', tooltipText: 'Refresh' },
      'Search',
      { text: '', id: 'clear-filter', align: 'Right', prefixIcon: 'fas fa-filter', cssClass: `grid-filter-icon`, tooltipText: 'Clear all Filters' }
    ] as any[];

    const SearchIndex = this.ooGrid?.toolbar.findIndex(item => item === 'Search');
    if (excelIconPermissions?.visible && this.sharedService.getUSER()?.role !== UserRoles.salesRep) {
      this.ooGrid?.toolbar.splice(SearchIndex + 1, 0, { text: '', id: 'excel-export', align: 'Right', prefixIcon: 'e-excelexport', cssClass: `${!excelIconPermissions?.enable ? 'disabled-grid-button' : ''}`, tooltipText: 'Excel Export' });
    }
    if (addIconPermissions?.visible) {
      this.ooGrid?.toolbar.splice(SearchIndex + 2, 0, { text: '', prefixIcon: 'fas fa-add', cssClass: `grid-add-button ${!addIconPermissions?.enable ? 'disabled-grid-button' : ''}`, id: 'add-new-record', tooltipText: 'Create Vacation Request' });
    }
  }

  getPermission(ruleAction: string): RolePermissionsModel {
    return this.PERMISSIONS?.find((e: RolePermissionsModel) => e.ruleAction === ruleAction)!;
  }

  getSetModuleStatuses() {
    this.vrService.getVacationRequestsStatus().subscribe({
      next: (res: any) => {
        this.vrService.setVRStatuses(res?.result);
      }
    })
  }
  onClose(refresh: boolean) {
    refresh && this.ooGrid.refresh();
    this.loadPermissions();
  }
  onGridActionBegin(args: any, grid?: any) {
    gridActionBeginForFilteringOdataV4(args);
  }
}
